import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";

import { navigate } from "../../../../helpers/utils.js";

import CloseIcon from "../../common/dialog/CloseIcon";
import cardStyles from "./cardStyles";
import CardUtils from "./CardUtils";
import ReflectionPieChart from "./ReflectionPieChart.js";
import appPages from "../../../../appPages";

export default function ReflectionCard({
  controller,
  data,
  isSnoozed = false,
  showManaMindful = () => {},
  onSnooze = () => {},
}) {
  const [showCard, setShowCard] = useState(false);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const saveCardData = (mood, note) => {
    setShowCard(false);
    if (showManaMindful) showManaMindful();

    controller.tracking.track("Edit Reflection Card Gem");
    const action = {
      action: "save",
      target: "gem",
      item_id: data.gem_target_id,
      time_unit: data.gem_time_unit,
      day: data.gem_day,
      item_type: data.gem_type,
      gem_id: data.gem_id,
      hours: data.tracked,
      note: note,
      mood: mood,
    };

    controller.cardAction(action);
  };

  const goToReflectionPage = () => {
    navigate(controller, appPages.reflectionPage);
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, styles.card]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />

        <ReflectionPieChart
          data={data}
          onChartPress={goToReflectionPage}
          saveCardData={saveCardData}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    paddingVertical: 0,
    paddingHorizontal: 8,
  },
});
